import { App } from 'widgets/topical-quiz/App';
import '../../styles/style.scss';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { store } from 'store';
import { persistor } from 'store';

const root = ReactDOM.createRoot(document.querySelector('.root-wisden-quiz'));

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);
